"use strict";

require("core-js/modules/es.array.map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataByDataSource = void 0;
var _DataSourceTypes = require("../enums/config/DataSourceTypes");
var getDataByDataSource = function getDataByDataSource(dataSource, dictionaries, configDictionaries) {
  switch (dataSource === null || dataSource === void 0 ? void 0 : dataSource.type) {
    case _DataSourceTypes.DataSourceTypes.Dictionary:
      {
        var dictionary = dictionaries[dataSource.source];
        return dictionary === null || dictionary === void 0 ? void 0 : dictionary.fields.map(function (item) {
          return {
            label: item.name,
            value: item.value
          };
        });
      }
    case _DataSourceTypes.DataSourceTypes.DictionaryConfig:
      {
        return configDictionaries[dataSource.source];
      }
    default:
      return [];
  }
};
exports.getDataByDataSource = getDataByDataSource;